<template>
    <div>
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/ClothManage' }">校服配置</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="10" style="display:flex;align-items:right;text-align: end;">
                        <el-col :span="24">
                            <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                             <el-button style="background-color: #ffb135;color: #fff" icon="el-icon-refresh-left" @click="reset()">重置</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="$refs.add.openDialog()">新增</el-button>
                        </el-col>
                    </el-row>
                     <el-table :data="tableData" style="width: 100%;margin-bottom:20px" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="100" align="center">
                            <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column prop="schoolName" label="学校名称" :resizable="false" align="center"></el-table-column>
                        <!-- <el-table-column prop="yaerDate" label="年份" :resizable="false" align="center"></el-table-column> -->
                        <!-- <el-table-column prop="seasonType" label="季度" :resizable="false" width="100" align="center"></el-table-column> -->
                        <el-table-column prop="qrContent" label="二维码" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-image
                                    style="width: 50px; height: 50px"
                                     alt="Image"
                                    :src="scope.row.qrContent"
                                     @click="check(scope.row)"
                                ></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <!-- <el-button type="text" size="small" @click="edit(scope.row.id)">修改</el-button> -->
                                <el-button type="text" size="small" @click="deleteClothes(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination> -->
                </el-card>
            </el-col>
        </el-row>
        <add ref="add" @getClothesSchoolList="getClothesSchoolList"
        ></add>
        <edit ref="edit" @getClothesSchoolList="getClothesSchoolList"
        ></edit>
        <el-dialog
            title="二维码"
            :visible.sync="dialogVisiblT"
            width="30%"
            :before-close="handleClose">
            <div class="check">
                <img  :src="imageBase" class="image"  alt="Image"/> 
            </div>
        </el-dialog>
    </div>
</template>
<script>
import add from './components/add.vue';
import edit from './components/edit.vue';
export default {
    data() {
        return {
            searchInput: '',
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                //款号
                clothesName: '',
                clothesSeason: '',
                clothesSubZone: ''
            },
            // 数据列表
            tableData: [],
            clothesZone: [],
            isGetDictionaryData: false,
            // 数据总数
            total: 0,
            dialogVisible: false,
            dialogVisiblT: false,
            clothesDictionary: [],
            imageBase: '',
        };
    },
    components: { add, edit },
    created() {
        // 获取数据列表
        this.getClothesSchoolList();
    },
    methods: {
        search() {
            this.searchInfo.pageNum = 1;
            this.getClothesSchoolList();
        },
        reset() {
            this.searchInfo = {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                //款号
                clothesName: '',
                clothesSeason: '',
                clothesSubZone: ''
            }
            this.search();
        },
        async getClothesSchoolList() {
            const res = await this.$axios.post('manage/cloth/searchClothesSchool', this.searchInfo);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        async deleteClothes(id) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .get('manage/cloth/deleteClothesSchool', {
                        params : {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getClothesSchoolList();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch(() => {
                        this.getClothesSchoolList();
                    });
            });
        },
        edit(data) {
            this.$refs.edit.getClothesInfo(data)
        },
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getClothesSchoolList();
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getClothesSchoolList();
        },

        handleToSearch() {
            this.searchInfo.pageNum = 1;
            this.getClothesSchoolList();
        },
        handleClosePwd() {
                    this.dialogVisible = false;
                },
        getBaseQr(qrContent) {
            // 创建FileReader对象
            let reader = new FileReader();
            // 读取二进制流数据并转换为Base64编码
            reader.readAsDataURL(new Blob([qrContent]));
            reader.onload = function() {
                return  reader.result;
                // 在Vue中使用base64字符串展示图片
            };
        },
        check(data) {
            this.imageBase  = data.qrContent
            this.dialogVisiblT = true
        },
        handleClose(){
            this.dialogVisiblT=false
        },     
    }
}
</script>
<style>
.el-table {
    margin-top: 20px;
}

</style>